<template>
  <div>
    <v-btn
      :to="'/events/' + $route.params.id"
      class="ma-0 mb-4"
      text
    >
      Назад
    </v-btn>

    <h1>{{ $store.getters.event.header }}</h1>
    <h1 class="mb-2">
      Новое бронирование
    </h1>
    <p
      v-if="servicesOnlyMode"
      class="grey--text mb-5"
    >
      Без размещения в номере — только дополнительные услуги
    </p>

    <v-row v-if="servicesOnlyMode">
      <v-col cols="7">
        <v-card>
          <v-card-title>Клиент</v-card-title>
          <v-card-text>
            <template v-if="currentClient">
              <div class="client-info-row">
                <span class="client-info-label">Имя</span>
                <span>{{ currentClient.name }}</span>
              </div>
              <div
                v-if="currentClient.phone"
                class="client-info-row"
              >
                <span class="client-info-label">Телефон</span>
                <span>{{ currentClient.phone }}</span>
              </div>
              <div
                v-if="currentClient.email"
                class="client-info-row"
              >
                <span class="client-info-label">Email</span>
                <span>{{ currentClient.email }}</span>
              </div>
              <v-divider class="my-3" />
              <div class="grey--text text--darken-1 text-caption mb-2">
                Сменить клиента
              </div>
            </template>
            <div
              v-else
              class="grey--text text--darken-1 text-caption mb-3"
            >
              Выберите или создайте клиента
            </div>
            <v-autocomplete
              v-model="select_user"
              :items="clientAutocompleteItems"
              :search-input.sync="client_search"
              item-value="id"
              item-text="name"
              label="Поиск по имени, телефону или email"
              outlined
              dense
              clearable
              no-filter
              :loading="clients_loading"
              @change="onClientSelected"
            >
              <template v-slot:selection="{ item }">
                {{ item.name }}<span v-if="item.phone"> · {{ item.phone }}</span>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.phone }} · {{ item.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <v-btn
              small
              text
              color="primary"
              class="mt-1"
              @click="createClientDialog = true"
            >
              + Создать нового клиента
            </v-btn>
          </v-card-text>
        </v-card>

        <template v-if="hasSelectedClient">
          <v-card class="mb-4 mt-4">
            <v-card-title>
              Услуги
              <v-spacer />
              <v-btn
                small
                color="primary"
                @click="openAddService"
              >
                Добавить
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div
                v-if="!draftServices.length"
                class="grey--text"
              >
                Добавьте хотя бы одну услугу
              </div>
              <div
                v-for="(svc, idx) in draftServices"
                :key="'draft-svc-' + idx"
                class="d-flex justify-space-between align-center mb-2"
              >
                <div>
                  <div class="font-weight-medium">{{ svc.name }}</div>
                  <div class="text-caption grey--text">
                    {{ svc.unit_price | format }} ₽ × {{ svc.quantity }}
                    <span v-if="svc.discount > 0"> · скидка {{ svc.discount | format }} ₽</span>
                  </div>
                </div>
                <div class="d-flex align-center">
                  <span class="font-weight-medium mr-2">{{ lineTotal(svc) | format }} ₽</span>
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="removeDraftService(idx)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>
              <v-divider v-if="draftServices.length" class="my-3" />
              <div
                v-if="draftServices.length"
                class="d-flex justify-space-between font-weight-bold"
              >
                <span>Итого</span>
                <span>{{ draftServicesTotal | format }} ₽</span>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="mb-4">
            <v-card-text>
              <v-textarea
                v-model="serviceComment"
                outlined
                dense
                hide-details
                rows="2"
                label="Комментарий (необязательно)"
              />
            </v-card-text>
          </v-card>

          <v-alert
            v-if="createError"
            type="error"
            dense
            class="mb-4"
          >
            {{ createError }}
          </v-alert>

          <v-btn
            color="success"
            large
            :loading="createLoading"
            :disabled="!draftServices.length"
            @click="createServiceReservation()"
          >
            Создать бронирование
          </v-btn>
        </template>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="7">
        <v-card>
          <v-card-title>Клиент</v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="select_user"
              :loading="loading"
              :items="users_list"
              item-text="email"
              item-value="id"
              :search-input.sync="search_user"
              autofocus
              label="Поиск пользователя"
              outlined
              dense
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Бронирование с номером -->
    <div v-if="!servicesOnlyMode && reservation_object && select_user">
      <v-row>
        <v-col
          cols="7"
          class="mb-6"
          xs="12"
          sm="12"
          md="12"
          lg="7"
        >
          <v-card class="overflow-hidden">
            <v-row class="ma-0 h-full">
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card-title
                  class="mt-2"
                  style="font-size: 25px; font-weigth: bold"
                >
                  {{ reservation_object.reservation.header }}
                </v-card-title>

                <v-card-text class="mb-0 pb-0">
                  <v-divider></v-divider>
                </v-card-text>
                <div
                  v-for="room in reservation_object.reservation.suits"
                  :key="room.id"
                >
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <v-card-title> {{ room.name }} №{{ room.room_number }}</v-card-title>
                      <v-card-subtitle class="text-xs pb-0">
                        {{ room.options.package }} <br />
                      </v-card-subtitle>
                    </div>
                    <v-btn
                      x-small
                      depressed
                      color="error"
                      @click="deleteRoom(reservation_object.uuid, room.id)"
                    >
                      Удалить номер
                    </v-btn>
                  </div>

                  <div>
                    <v-card-title class="pb-0 mb-0">
                      Тип номера
                    </v-card-title>
                    <v-card-text>
                      <v-radio-group v-model="room.options.type">
                        <v-radio
                          v-for="(t, key) in room.room_available_type"
                          :key="t"
                          :label="t"
                          :value="key"
                        ></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </div>

                  <div v-show="room.options.type == '1'">
                    <v-card-title class="pb-0 mb-0">
                      Пол участника
                    </v-card-title>
                    <v-card-text>
                      <v-radio-group v-model="room.options.gender">
                        <v-radio
                          v-for="(g, key) in room.available_gender"
                          :key="g"
                          :label="g"
                          :value="key"
                        ></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </div>

                  <v-card-text>
                    <v-divider></v-divider>
                  </v-card-text>
                  <div
                    v-for="(participant, index) in room.participants"
                    :key="participant.index"
                  >
                    <v-card-title>
                      <span>Данные {{ index + 1 }}-го участника </span>
                      <v-spacer></v-spacer>
                      <v-btn
                        x-small
                        depressed
                        color="error"
                        @click="deletePeople(room.participants, index)"
                      >
                        Удалить
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-text-field
                        v-model="participant.name"
                        outlined
                        hide-details
                        label="Фамилия Имя"
                        required
                      ></v-text-field>

                      <v-checkbox
                        v-model="participant.show_in_list"
                        class="mt-2"
                        label="Показывать имя в списке участников или отобразить как ***"
                      ></v-checkbox>

                      <div
                        class="d-flex"
                        style="margin-bottom: 30px"
                      >
                        <div>
                          <div class="label">
                            Дата заезда
                          </div>
                          <date-picker
                            v-model="participant.start"
                            :lang="lang"
                            type="date"
                            value-type="format"
                            class="v-input__control mr-md-4 mr-sm-4"
                            :format="'YYYY-MM-DD'"
                          ></date-picker>
                        </div>
                        <div>
                          <div class="label">
                            Дата выезда
                          </div>
                          <date-picker
                            v-model="participant.end"
                            :lang="lang"
                            type="date"
                            value-type="format"
                            class="v-input__control mr-md-4 mr-sm-4"
                            :format="'YYYY-MM-DD'"
                          ></date-picker>
                        </div>
                      </div>

                      <label for="participantType">Тип Питания</label>
                      <v-radio-group
                        id="participantType"
                        v-model="participant.food"
                        mandatory
                      >
                        <v-radio
                          label="Стандартное"
                          value="Стандартное"
                        ></v-radio>
                        <v-radio
                          label="Вегетарианское"
                          value="Вегетарианское"
                        ></v-radio>
                      </v-radio-group>

                      <label for="participantType">Тип участника</label>
                      <v-radio-group
                        id="participantType"
                        v-model="participant.participantType"
                        mandatory
                      >
                        <v-radio
                          label="Спортсмен"
                          value="Спортсмен"
                        ></v-radio>
                        <v-radio
                          label="Сопровождающий"
                          value="Сопровождающий"
                        ></v-radio>
                      </v-radio-group>

                      <label for="participantType">Возраст участника</label>
                      <v-radio-group
                        id="participantType"
                        v-model="participant.age"
                        mandatory
                      >
                        <v-radio
                          label="Взрослый"
                          value="Взрослый"
                        ></v-radio>
                        <v-radio
                          label="Ребенок (до 13 лет включительно)"
                          value="Ребенок (до 13 лет включительно)"
                        ></v-radio>
                      </v-radio-group>

                      <v-text-field
                        v-show="participant.age != 'Взрослый'"
                        v-model="participant.childAge"
                        outlined
                        hide-details
                        label="Полных лет на дату заезда"
                        class="v-label_small"
                      ></v-text-field>

                      <v-checkbox
                        v-model="participant.insurance"
                        hide-details
                        label="Добавить страховку от невыезда"
                      ></v-checkbox>
                      <v-text-field
                        v-model="participant.discount_admin"
                        outlined
                        hide-details
                        label="Скидка"
                        class="v-label_small mt-5"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="participant.discount_text"
                        outlined
                        hide-details
                        label="discount_text"
                        class="v-label_small mt-5"
                        required
                      ></v-text-field>
                      <v-checkbox
                        v-model="participant.no_count"
                        class=""
                        label="Скрыть участника из всех списков"
                      ></v-checkbox>
                      <v-divider class="mt-10"></v-divider>
                    </v-card-text>
                  </div>
                  <v-btn
                    v-if="room.participants.length < room.capacity && room.options.type !== 0"
                    x-small
                    depressed
                    class="small-btn"
                    color="primary"
                    @click="addPeople(room.participants)"
                  >
                    Добавить участника
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-btn
            class="ma-0 mb-5 mt-5"
            color="success ml-5"
            @click="updateReservation()"
          >
            Сохранить
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-dialog
      v-model="addServiceDialog"
      max-width="480"
    >
      <v-card>
        <v-card-title>Добавить услугу</v-card-title>
        <v-card-text>
          <v-select
            v-model="newService.service_id"
            :items="catalogServices"
            item-value="id"
            item-text="name"
            label="Услуга из каталога"
            outlined
            dense
            clearable
            @change="onCatalogServiceChange"
          />
          <v-text-field
            v-model="newService.name"
            outlined
            dense
            label="Название"
          />
          <v-text-field
            v-model.number="newService.unit_price"
            type="number"
            outlined
            dense
            label="Цена за единицу, ₽"
            min="0"
          />
          <v-text-field
            v-model.number="newService.quantity"
            type="number"
            outlined
            dense
            label="Кол-во"
            min="1"
          />
          <v-text-field
            v-model.number="newService.discount"
            type="number"
            outlined
            dense
            label="Скидка, ₽"
            min="0"
          />
          <v-text-field
            v-model="newService.discount_text"
            outlined
            dense
            label="Описание скидки"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="addServiceDialog = false">Отмена</v-btn>
          <v-btn
            color="primary"
            @click="confirmAddService"
          >
            Добавить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="createClientDialog"
      max-width="480"
    >
      <v-card>
        <v-card-title>Создать клиента</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newClient.name"
            outlined
            dense
            label="Имя"
          />
          <v-text-field
            v-model="newClient.phone"
            outlined
            dense
            label="Телефон (+79...)"
          />
          <v-text-field
            v-model="newClient.email"
            outlined
            dense
            label="Email"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="createClientDialog = false">Отмена</v-btn>
          <v-btn
            color="primary"
            :loading="createClientLoading"
            @click="doCreateClient"
          >
            Создать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/api'
import router from '@/router'
import { mdiCursorDefaultGestureOutline } from '@mdi/js'
import AddRoomModal from '@/views/events/AddRoomModal.vue'

export default {
  components: { AddRoomModal },
  filters: {
    format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 '),
  },
  data() {
    return {
      reservation_object: null,
      users_list: [],
      search_user: null,
      select_user: null,
      loading: false,
      new_reservation_popup: false,
      free_event_rooms: [],
      loader: false,
      catalogServices: [],
      draftServices: [],
      serviceComment: '',
      addServiceDialog: false,
      newService: {
        service_id: null,
        name: '',
        unit_price: 0,
        quantity: 1,
        discount: 0,
        discount_text: '',
      },
      createLoading: false,
      createError: null,
      clients_list: [],
      client_search: null,
      clients_loading: false,
      selectedClient: null,
      createClientDialog: false,
      createClientLoading: false,
      newClient: { name: '', phone: '', email: '' },
    }
  },
  computed: {
    servicesOnlyMode() {
      return this.$route.query.mode === 'services'
    },
    draftServicesTotal() {
      return this.draftServices.reduce(
        (sum, svc) => sum + this.lineTotal(svc),
        0,
      )
    },
    hasSelectedClient() {
      return Boolean(this.select_user || this.selectedClient)
    },
    currentClient() {
      if (this.selectedClient) return this.selectedClient
      if (!this.select_user) return null
      return this.clients_list.find(
        c => Number(c.id) === Number(this.select_user),
      ) || null
    },
    clientAutocompleteItems() {
      const items = [...this.clients_list]
      const current = this.currentClient
      if (current && !items.some(c => Number(c.id) === Number(current.id))) {
        items.unshift(current)
      }
      return items
    },
  },
  watch: {
    select_user(val) {
      if (this.reservation_object) {
        this.reservation_object.user_id = val
      }
      if (!val) {
        this.selectedClient = null
      }
    },
    async client_search(val) {
      if (!this.servicesOnlyMode) return
      if (!val || val.length < 2) {
        this.ensureSelectedClientInList()
        return
      }
      this.clients_loading = true
      try {
        const results = await Api.getClients({ search: val })
        const current = this.currentClient
        if (current && !results.some(c => Number(c.id) === Number(current.id))) {
          this.clients_list = [current, ...results]
        } else {
          this.clients_list = results
        }
        this.ensureSelectedClientInList()
      } catch (e) {
        console.error(e)
      } finally {
        this.clients_loading = false
      }
    },
  },
  created() {
    this.$watch(() => this.$route.params)
  },
  async mounted() {
    if (this.servicesOnlyMode) {
      await this.loadCatalogServices()
      return
    }
    await this.getUsers()
    await this.getFrontReservation()
  },
  methods: {
    onClientSelected(userId) {
      if (!userId) {
        this.selectedClient = null
        return
      }
      const client = this.clientAutocompleteItems.find(
        c => Number(c.id) === Number(userId),
      )
      if (client) {
        this.selectedClient = client
        this.select_user = Number(client.id)
        this.ensureSelectedClientInList()
      }
    },
    ensureSelectedClientInList() {
      if (!this.selectedClient) return
      const id = Number(this.selectedClient.id)
      if (!this.clients_list.some(c => Number(c.id) === id)) {
        this.clients_list = [this.selectedClient, ...this.clients_list]
      }
    },
    lineTotal(svc) {
      return (
        (Number(svc.unit_price) || 0) * (Number(svc.quantity) || 1)
        - (Number(svc.discount) || 0)
      )
    },
    async loadCatalogServices() {
      try {
        this.catalogServices = await Api.getEventServices({
          event_id: this.$route.params.id,
        })
      } catch (e) {
        console.error(e)
      }
    },
    openAddService() {
      this.newService = {
        service_id: null,
        name: '',
        unit_price: 0,
        quantity: 1,
        discount: 0,
        discount_text: '',
      }
      this.addServiceDialog = true
    },
    onCatalogServiceChange(id) {
      const svc = this.catalogServices.find(s => s.id === id)
      if (svc) {
        this.newService.name = svc.name
        this.newService.unit_price = svc.price
      }
    },
    confirmAddService() {
      if (!this.newService.name) return
      this.draftServices.push({ ...this.newService })
      this.addServiceDialog = false
    },
    removeDraftService(index) {
      this.draftServices.splice(index, 1)
    },
    async doCreateClient() {
      if (!this.newClient.phone) return
      this.createClientLoading = true
      try {
        const result = await Api.createClientAdmin(this.newClient)
        this.selectedClient = result
        this.clients_list = [result, ...this.clients_list.filter(
          c => Number(c.id) !== Number(result.id),
        )]
        this.select_user = Number(result.id)
        this.createClientDialog = false
        this.newClient = { name: '', phone: '', email: '' }
      } catch (e) {
        console.error(e)
      } finally {
        this.createClientLoading = false
      }
    },
    async createServiceReservation() {
      const userId = Number(this.select_user || (this.selectedClient && this.selectedClient.id))
      if (!userId || !this.draftServices.length) return

      this.createLoading = true
      this.createError = null

      try {
        const result = await Api.addServiceReservation({
          event_id: parseInt(this.$route.params.id),
          user_id: userId,
          comment: this.serviceComment,
          services: this.draftServices.map(svc => ({
            service_id: svc.service_id,
            name: svc.name,
            unit_price: svc.unit_price,
            quantity: svc.quantity,
            discount: svc.discount,
            discount_text: svc.discount_text,
          })),
        })

        await Api.reservationSuccess({
          reservation_uuid: result.reservation_udid,
          user_id: userId,
        })

        this.$router.push({
          path: `/events/${this.$route.params.id}/${result.reservation_uuid}`,
          replace: true,
        })
      } catch (err) {
        this.createError = (
          err.response
          && err.response.data
          && (err.response.data.error || err.response.data.detail)
        ) || 'Не удалось создать бронирование'
      } finally {
        this.createLoading = false
      }
    },
    async getFrontReservation() {
      try {
        Api.getReservation({
          reservation_uuid: this.$store.getters.reservation.user_reservation_uuid,
        })
          .then(
            (event => {
              this.$set(this, 'reservation_object', event)
            }),
          )
          .catch(error => {
            if (error.response.status === 400) {
              this.$store.dispatch('clearReservationData')
              this.$router.push({
                path: `/events/${this.$route.params.id}`,
                replace: true,
              })
            } else {
              // Handle else
            }
          })
      } catch (error) {
        this.$router.push({
          path: `/events/${this.$route.params.id}`,
          replace: true,
        })
      }
    },
    async getUsers() {
      try {
        Api.getUsers().then(
          (event => {
            this.$set(this, 'users_list', event)
          }),
        )
      } catch {}
    },
    async updateReservation() {
      try {
        Api.updateReservation(this.reservation_object).then(
          (event => {
            this.$store.dispatch('clearReservationData')

            Api.reservationSuccess({
              reservation_uuid: this.reservation_object.uuid,
              user_id: this.reservation_object.user_id,
            })
              .then(
                (event => {
                  this.$router.push({
                    path: `/events/${this.$route.params.id}/${this.reservation_object.reservation_uuid}`,
                    replace: true,
                  })
                }),
              )
              .catch(error => {
                if (error.response.status === 400) {
                } else {
                }
                console.log(error.response)
              })
          }),
        )
      } catch {}
    },
    getFreeEventRooms() {
      try {
        this.loader = true
        Api.getFreeEventRooms({
          event_id: parseInt(this.$route.params.id),
        }).then(
          (event => {
            this.$set(this, 'free_event_rooms', event)
            this.$set(this, 'new_reservation_popup', true)
            this.$set(this, 'loader', false)
          }),
        )
      } catch (error) {
        this.$set(this, 'loader', false)
      }
    },
    async checkInvoice() {
      try {
        Api.checkInvoice({
          reservation_uuid: this.reservation_object.reservation_uuid,
        }).then(
          (event => {
            this.$router.push({
              path: `/events/${this.$route.params.id}/${this.$route.params.reservation_id}`,
              replace: true,
            })
          }),
        )
      } catch (error) {
        console.log(error)
      }
    },
    deletePeople(array, index) {
      // console.log(participant, index)
      array.splice(index, 1)
    },
    async deleteRoom(reservation_uuid, event_room_id) {
      try {
        Api.deleteReservation({
          reservation_uuid,
          event_room_id,
        }).then(
          (event => {
            this.getFrontReservation()
          }),
        )
      } catch (error) {
        console.log(error)
      }
    },
    addPeople(array) {
      array.push({
        age: '',
        childAge: null,
        gender: '',
        food: '',
        insurance: false,
        show_in_list: true,
        no_count: false,
        name: '',
        participantType: '',
        phone: '',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.client-info-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
  font-size: 14px;
}

.client-info-label {
  color: rgba(0, 0, 0, 0.6);
}
</style>
